import * as actionTypes from '../constants/actionType';
import initialState from './initialState';


export default function mRelatedProjectsReducer(state = initialState.mRelatedProjects, action) {
  switch (action.type) {
    case actionTypes.MRELATEDPROJECTS_LOAD_START:
      return {
        ...state,
        isLoading: true
      };

    case actionTypes.MRELATEDPROJECTS_LOAD_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.error
      };

    case actionTypes.MRELATEDPROJECTS_LOAD_SUCCESS: {
      return {
        ...state,
        ...action.data,
        isLoading: false,
        error: undefined
      };
    }

    default:
      return state;
  }
}
